// extracted by mini-css-extract-plugin
module.exports = {"orderByMenu":"customCardsOrderByDropdown_orderByMenu__ehm5N"};